import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaBuilding } from 'react-icons/fa';

const offices = [
  {
    country: 'India - Hyderabad',
    name: 'Inovaantage Pvt Ltd',
    address: 'R R Towers 4th Floor, Plot no 188 & 189, Phase 2, Kavuri Hills, Madhapur Hyderabad, Telangana 500033',
    phone: '',
    mapSrc:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.0959969132717!2d78.39396867509363!3d17.431241102582315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91f289f55b0b%3A0xf91a80568c49f99a!2sRR%20Towers%204%2C%20Kavuri%20Hills%2C%20Madhapur%2C%20Hyderabad%2C%20Telangana%20500081!5e0!3m2!1sen!2sin!4v1718017088910!5m2!1sen!2sin',
  },
  {
    country: 'USA - Denver',
    name: 'Inovaantage Inc.',
    address: '1312 17th Street Unit #2229, Denver, CO 80202',
    phone: '+1 720-263-9280',
    mapSrc: 'https://www.google.com/maps?q=1312+17th+Street,+Unit+%232229,+Denver,+CO+80202&output=embed',
  },
  {
    country: 'UK - Reading',
    name: 'Inovaantage Ltd.',
    address: '61A Bath Road, Reading, RG30 2BB',
    phone: '+44 7818 951496',
    mapSrc: 'https://www.google.com/maps?q=61A+Bath+Road,+Reading,+RG30+2BB&output=embed',
  },
  {
    country: 'Malaysia - Kuala Lumpur',
    name: 'Inovaantage Sdn Bhd.',
    address:
      'Level 28, The Gardens South Tower, Mid Valley City, Lingkaran Syed Putra, 59200 Kuala Lumpur',
    phone: '+603-2298-7135 / +603-2298-7333',
    mapSrc: 'https://www.google.com/maps?q=Mid+Valley+City,+Kuala+Lumpur,+Malaysia&output=embed',
  },
  {
    country: 'Australia - Adelaide',
    name: 'Inovaantage Pty Ltd.',
    address: '8 Beulah Road, Norwood SA 5067, Adelaide, Australia',
    phone: '',
    mapSrc: 'https://www.google.com/maps?q=8+Beulah+Road,+Norwood,+Adelaide,+Australia&output=embed',
  },
  {
    country: 'Singapore',
    name: 'Inovaantage Pte Ltd.',
    address: '12 Marina Boulevard, 17-01 Tower 3, Marina Bay Financial Centre, Singapore 018982',
    phone: '+65 6549 7044 / +65 6549 7001',
    mapSrc: 'https://www.google.com/maps?q=Marina+Bay+Financial+Centre,+Singapore&output=embed',
  },
  {
    country: 'Philippines - San Juan City',
    name: 'Inovaantage Pty Ltd.',
    address: 'Unit 301, 164 L. Gruet Street, Brgy Maytunas, San Juan City, Philippines 1500',
    phone: '',
    mapSrc: 'https://www.google.com/maps?q=San+Juan+City,+Philippines&output=embed',
  },
];

const Offices = () => {
  return (
    <div className="bg-white py-12 px-4 sm:px-8 lg:px-16">
      <h2 className="text-4xl font-bold text-center text-blue-900 mb-16 flex items-center justify-center gap-3">
        <FaBuilding className="text-blue-700" /> Our Global Offices
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {offices.map((office, index) => (
          <div
            key={index}
            className="bg-white shadow-lg border border-gray-200 rounded-lg p-6 flex flex-col items-center text-center space-y-4 hover:shadow-xl transition-shadow duration-300"
          >
            <FaMapMarkerAlt className="text-orange-500 text-4xl" />
            <h3 className="text-xl font-semibold text-orange-600">{office.country}</h3>
            <p className="text-base font-medium text-gray-800">{office.name}</p>
            <p className="text-sm text-gray-600">{office.address}</p>

            {office.phone && (
              <p className="flex items-center justify-center gap-2 text-gray-700 text-sm">
                <FaPhoneAlt className="text-green-600" /> {office.phone}
              </p>
            )}

            {office.mapSrc ? (
              <div className="w-full aspect-[16/9] rounded-md overflow-hidden mt-4">
                <iframe
                  title={office.name}
                  src={office.mapSrc}
                  width="100%"
                  height="100%"
                  allowFullScreen
                  loading="lazy"
                  style={{ border: 0 }}
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            ) : (
              <p className="text-sm text-red-500 mt-4">Map unavailable for this location.</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Offices;
